import './Login.scss'
import { useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import { Link } from 'react-router-dom'
import {Button} from '@mui/material';
import homeScreen1 from '../../assets/images/login/landscape/Homescreen-01.jpg';
import homeScreenSm1 from '../../assets/images/login/portrait/Homescreen-01.jpg';
import homeScreen2 from '../../assets/images/login/landscape/Homescreen-02.jpg';
import homeScreenSm2 from '../../assets/images/login/portrait/Homescreen-02.jpg';
import homeScreen3 from '../../assets/images/login/landscape/Homescreen-03.jpg';
import homeScreenSm3 from '../../assets/images/login/portrait/Homescreen-03.jpg';
import homeScreen4 from '../../assets/images/login/landscape/Homescreen-04.jpg';
import homeScreenSm4 from '../../assets/images/login/portrait/Homescreen-04.jpg';
import logo from '../../assets/images/logo.svg';
import {pushSiteInfo, registerPageInfo} from '../../helpers/analyticsHelper';
import { useAuth } from '../../providers/Auth';

const Login = () => {
    const { signIn} = useAuth();
    const { t } = useTranslation();
    const imageSources = [
        {
            'landscape': homeScreen1,
            'portrait': homeScreenSm1,
            'msg': t('LoginPage.msg1')
        },
        {
            'landscape': homeScreen2,
            'portrait': homeScreenSm2,
            'msg': t('LoginPage.msg2')
        },
        {
            'landscape': homeScreen3,
            'portrait': homeScreenSm3,
            'msg': t('LoginPage.msg3')
        },
        {
            'landscape': homeScreen4,
            'portrait': homeScreenSm4,
            'msg': t('LoginPage.msg4')
        }
    ]
    const imageSource = imageSources[Math.floor(Math.random() * imageSources.length)];

    useEffect(() => {
        pushSiteInfo(null, null);
        registerPageInfo('my access app|login', {
            "level1": "my access app",
            "level2": "login",
            "level3": null,
            "level4": null
        })
    }, []);

    localStorage.setItem('showIADP', 'true');

    return (
        <>
            <div className="c-login">
                <div className="c-background">
                    <picture>
                        <source media='(min-width:1101px)' srcSet={`${imageSource.landscape}`} />
                        <source media='(max-width:1100px)' srcSet={`${imageSource.portrait}`} />
                        <img src={imageSource.landscape} alt={t('LoginPage.altBanner')} />
                    </picture>
                </div>
                <div className="c-banner">
                    <img className="image-logo" src={logo} alt={t('LoginPage.altLogo')}  />
                    <div>
                        <div className="c-name-slogan">
                            <h1>{t('AppName')}</h1>
                            <span className='label-slogan'>{t('LoginPage.withCare')}</span>
                        </div>
                        <div className='label-access-policy'>
                            {t('LoginPage.googleAccessPolicy1')} 
                            <Link className='label-link' to="/google-access-policy"> {t('LoginPage.clickHere')} </Link> 
                            {t('LoginPage.googleAccessPolicy2')}
                        </div>
                    </div>
                    <Button
                        className="btn-login"   
                        disableElevation
                        disableRipple
                        onClick={signIn}
                    >
                        {t('LoginPage.loginBtn')}
                    </Button>
                </div>
                <div className="c-image-msg">
                    <span className="label-msg">{imageSource.msg}</span>
                </div>
            </div>
        </>
    )
}

export default Login;
